// @ts-nocheck
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { goalActions } from '../../../../../../../../../store';
import DurationMCRow from '../common/components/durationMCRow';
import {
  DurationMethodMCMeasurementModeEnum,
  MasteryCriteriaChangeTypeEnum,
} from '../../../../constants/general';

import type {
  ITreatmentPlanGoal,
} from '../../../../../../../../../utils/types';
import type { IDurationMastryCriteriaState } from '../common/types/states';

interface ISingleRowDurationMasteryCriteria {
  isPCGGoal?: boolean;
  goal: ITreatmentPlanGoal;
  goalIndex: number;
  isEditable: boolean;
}

function SingleRowDurationMasteryCriteria({
  isPCGGoal,
  goal,
  goalIndex,
  isEditable,
}: ISingleRowDurationMasteryCriteria) {
  const dispatch = useDispatch();

  const { mastery_criteria, measurement_units } = goal;
  const { desired_amount, practice_duration_count, measurement_mode, change_type } =
    mastery_criteria && 'measurement_mode' in mastery_criteria
      ? mastery_criteria
      : {};

  const [masteryCriteriaState, setMasteryCriteriaMCState] = useState<IDurationMastryCriteriaState>({
    change_type: change_type ?? MasteryCriteriaChangeTypeEnum.INCREASE,
    measurement_mode: measurement_mode ?? DurationMethodMCMeasurementModeEnum.AVERAGE,
    desired_amount: desired_amount ?? null,
    practice_duration_count: practice_duration_count ?? null,
  });
  const [isDirty, setIsDirty] = useState(false);

  const handleMCState = (key: string, value: number | string | null) => {
    setMasteryCriteriaMCState((prev) => ({
      ...prev,
      [key]: value,
    }));
    setIsDirty(true);
  };

  useEffect(() => {
    const { mastery_criteria } = goal;
    const { desired_amount, practice_duration_count, change_type, measurement_mode } =
      mastery_criteria && 'measurement_mode' in mastery_criteria
        ? mastery_criteria
        : {};
    if (!goal?.is_editing) {
      setIsDirty(false);
    }
    setMasteryCriteriaMCState({
      change_type: change_type ?? MasteryCriteriaChangeTypeEnum.INCREASE,
      desired_amount: desired_amount ?? null,
      practice_duration_count: practice_duration_count ?? null,
      measurement_mode: measurement_mode ?? DurationMethodMCMeasurementModeEnum.AVERAGE,
    });
  }, [goal?.is_editing, goal?.id]);

  useEffect(() => {
    if (!isDirty) return;
    dispatch(
      goalActions.updateGoalProperty({
        goalIndex,
        goalType: goal.goal_type,
        key: 'mastery_criteria',
        value: masteryCriteriaState,
      }),
    );
    dispatch(
      goalActions.updateGoalProperty({
        goalIndex,
        goalType: goal.goal_type,
        key: 'dirty',
        value: true,
      }),
    );
  }, [masteryCriteriaState]);

  return (
    <>
      <DurationMCRow
        onUpdate={handleMCState}
        goalIndex={goalIndex}
        isPCGGoal={isPCGGoal}
        isEditing={Boolean(goal?.is_editing)}
        baseline_at_creation={
          goal.baseline_at_creation === null ? null : Number(goal.baseline_at_creation)
        }
        values={masteryCriteriaState}
        isEditable={isEditable}
        measurementUnits={measurement_units && 'duration_unit' in measurement_units ? measurement_units : {}}
      />
    </>
  );
}

export default SingleRowDurationMasteryCriteria;
